import { call, put, takeEvery, takeLatest, delay } from "redux-saga/effects"
import toastr from "toastr"
import {
  ADD_FAVOURITE,
  GET_FAVOURITE
  
} from "./actionTypes"
import {
  addFavouriteFail,
  addFavouriteSuccess,
  getFavouriteFail,getFavouriteSuccess

 
} from "./actions"

import {
  addFavApi,
  getFavApi
 
} from "helpers/backend_helper"

toastr.options = {
  newestOnTop: true,
  progressBar: true,
}

function* addFavSaga({ payload: { data, callback } }) {

  try {
    const response = yield call(addFavApi, data)
    callback && callback(response);

    if (response.status == "failure") {
      return yield put(addFavouriteFail(response.message))
    }
    yield put(addFavouriteSuccess(response))
  } catch (error) {
    yield put(addFavouriteFail(error))
  }
}


function* getFavSaga({ payload: { data, callback } }) {

  try {
    const response = yield call(getFavApi, data)
    callback && callback(response);

    if (response.status == "failure") {
      return yield put(getFavouriteFail(response.message))
    }
    yield put(getFavouriteSuccess(response))
  } catch (error) {
    yield put(getFavouriteFail(error))
  }
}




function* blogsSaga() {
  yield takeLatest(ADD_FAVOURITE, addFavSaga)
  yield takeLatest(GET_FAVOURITE, getFavSaga)


}

export default blogsSaga
